import SiteEnum from './enums/SiteEnum';
import ThemeEnum from './enums/ThemeEnum';
import VariantTypeEnum from './enums/VariantTypeEnum';
import { IImage } from './IImage';
import { ILink } from './ILink';
import { IVideo } from './IVideo';

export interface IHeroBase {
  readonly backgroundColour?: string;
  readonly fontColour: ThemeEnum;
  readonly image?: IImage;
  readonly mobileImage?: IImage;
  readonly playButtonLabel: string;
  readonly site: SiteEnum;
  readonly subText?: string;
  readonly title?: string;
  readonly trumpetText?: string;
  readonly variant: HeroVariantEnum;
  readonly video?: IVideo;
  readonly videoConfig: string;
  readonly deactivateAutoplay?: boolean;
}
export interface IArticleHeader extends IHeroBase {
  readonly hasPlayButton: boolean;
}

export interface IMediaHero extends IHeroBase {
  readonly hasQBrickPlayButton: boolean;
  readonly trumpetImage?: IImage;
  readonly ctaOne?: ILink;
  readonly ctaStyle?: VariantTypeEnum;
  readonly ctaTwo?: ILink;
}

export enum HeroVariantEnum {
  Full = 'fullWidth',
  FullLarge = 'fullWidthLargeText',
  Split = 'split',
  SplitReverse = 'splitReverse',
  Stacked = 'stacked',
}
